/* Completion touches each transform once; the browser animates every frame. */
(() => {
  const completions = new WeakMap();
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const parts = layer => [...(layer?.querySelectorAll('[data-ak-loader-half]') || [])];
  function angle(part) {
    const transform = getComputedStyle(part).transform;
    if (transform === 'none') return 0;
    const matrix = new DOMMatrixReadOnly(transform);
    const degrees = (Math.atan2(matrix.b, matrix.a) * 180 / Math.PI + 360) % 360;
    return degrees > 359.99 ? 0 : Math.min(180, degrees);
  }
  function reset(layer) {
    if (!layer) return;
    completions.delete(layer);
    layer.classList.remove('is-completing');
    layer.classList.add('is-resetting');
    parts(layer).forEach(part => {
      part.getAnimations().forEach(animation => animation.cancel());
      part.style.removeProperty('animation');
      part.style.removeProperty('transform');
    });
    // Commit an empty black ring before the new forward animation starts.
    layer.getBoundingClientRect();
    layer.classList.remove('is-resetting');
  }
  function finish(layer) {
    if (!layer) return Promise.resolve();
    if (completions.has(layer)) return completions.get(layer).promise;
    const halves = parts(layer);
    if (halves.length !== 2) return Promise.resolve();
    const angles = halves.map(angle);
    const remaining = 360 - angles[0] - angles[1];
    const duration = reduced.matches || remaining < .001 ? 0 : 500;
    const rightDuration = remaining > 0 ? duration * (180 - angles[0]) / remaining : 0;
    const state = {};
    const animations = [];
    completions.set(layer, state);
    halves.forEach((part, index) => {
      // Freeze the current painted angle, then finish clockwise in order.
      part.style.animation = 'none';
      part.style.transform = `rotate(${angles[index]}deg)`;
      if (!duration) { part.style.transform = 'rotate(180deg)'; return; }
      animations.push(part.animate([
        {transform:`rotate(${angles[index]}deg)`},
        {transform:'rotate(180deg)'}
      ], {
        duration:index === 0 ? rightDuration : duration - rightDuration,
        delay:index === 0 ? 0 : rightDuration,
        easing:'linear', fill:'both'
      }));
    });
    state.promise = Promise.allSettled(animations.map(animation => animation.finished)).then(() => {
      if (completions.get(layer) !== state) return;
      halves.forEach(part => { part.style.transform = 'rotate(180deg)'; });
      animations.forEach(animation => animation.cancel());
    });
    return state.promise;
  }
  window.AKLoaderMotion = {reset, finish};
})();
